

























































import { Component, Vue, Watch } from "vue-property-decorator";
import { getPurePcEngineDownloadUrl } from "@/req/homes";

@Component({
  components: {},
})
export default class Home extends Vue {
  public modal = false;
  public agree = false;
  public engineId: any = "";
  public verificationForm: any = {
    username: "",
    password: "",
  };
  public verificationRules = {
    username: [
      { required: true, message: "请输入正确的账号", trigger: "blur" },
    ],
    password: [
      { required: true, message: "请输入正确的密码", trigger: "blur" },
    ],
  };
  public show(id) {
    this.engineId = id;
    this.modal = true;
  }
  public clearBlank(str) {
    // 空格回退
    this.verificationForm[str] = this.verificationForm[str].replace(/[, ]/g, "");
  }
  public async handleSubmit() {
    if (!this.agree) return this.$Message.error("请阅读并同意使用协议！");
    const $formRef: any = this.$refs.formRef
    $formRef.validate(async (valid) => {
      if (valid) {
        const obj = {
          username: this.verificationForm.username,
          password: this.verificationForm.password,
          engine_id: this.engineId,
        };
        const res = await getPurePcEngineDownloadUrl(obj);
        if (res.code == 200) {
          window.open(res.data, "_blank");
          this.cancel();
        } else {
          this.$Message.error(res.msg);
        }
      }
    })
  }
  public agreementClick() {
    window.open("https://docs.qq.com/doc/DWkNKWFFqekFJV2lF", "_blank");
  }
  public toReagister() {
    this.modal = false;
    this.$emit("registerBtn");
  }
  public cancel() {
    const $formRef: any = this.$refs.formRef
    $formRef.resetFields()
    this.agree = false;
    this.modal = false;
  }
}
